import React from "react";

function MembersListComponent(props) {
  let members = props.members;

  return (
    <div>
      {members && members.length
        ? members.map((member) => {
            return (
              <div className="row mx-5 posts" key={member.member_id}>
                <div className="card mb-3">
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="card-body">
                        <h5 className="card-title">
                          {member.name} - {member.institution}
                        </h5>
                        <p className="card-text m-0">
                          <a
                            className="link link--metis"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={member.link_curriculum}
                          >
                            Visualizar o currículo Lattes.
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        : null}
    </div>
  );
}

export default MembersListComponent;
